export default __webpack_public_path__ + "static/media/avatarMin.69bea931.png";